import {useEffect, useState} from "react";

export const usePaymentType = ({paymentOptions, product, setPartPay, setInstallment}) => {
    const [selectedPaymentType, setSelectedPaymentType] = useState('partial');
    const hasPartialPayment = paymentOptions?.option20 || paymentOptions?.option50;
    const hasInstallment = product?.visible_installment && product?.installment.length > 0;

    useEffect(() => {
        if (!hasPartialPayment && hasInstallment) {
            setSelectedPaymentType('installment');
        } else {
            setSelectedPaymentType(prev => prev || 'partial');
        }
    }, [hasPartialPayment, hasInstallment]);

    const handlePaymentTypeSelect = (selectedOption) => {
        setSelectedPaymentType(selectedOption.type);

        if (selectedOption.type === 'installment') {
            setPartPay(100);
        }
        if (selectedOption.type === 'partial') {
            setInstallment(null);
        }
    };

    return {hasPartialPayment, hasInstallment, selectedPaymentType, handlePaymentTypeSelect}
}